import React from 'react'
import Header from './Header/Header'
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    secondaryRoot:{
        display: 'flex',
        flex:1,
        flexDirection: 'column',
        // background:'red',
        height: '100%'
    },
    flexChild: {
        flex: 1,
        // background:'green',
        paddingTop: 64,
    },
    // header:{
    //     flex: 1,
    //     background:'yellow',
    // }
}))
const Secondary= props => {
    const {children}= props
    const classes = useStyles()

    return (
        <div className={classes.secondaryRoot}>
            {/* <div className={classes.header}>
                <Header />
            </div> */}
            <div>
                <Header />
            </div>
            <div className={classes.flexChild}>
                    {children}
            </div>
            {/* <div>
                other data
            </div> */}
        </div>
    )
}

export default Secondary
Secondary.propTypes = {
    children: PropTypes.node
}